import React, { Component } from 'react';
import { Tabs, Tab, Col, ButtonToolbar , Button } from 'react-bootstrap';
import Toggle from 'react-toggle'

import { PropTypes } from 'prop-types';
import { PathsActive } from './PathsActive';
import { PathsDraft } from './PathsDraft';
import { PathActiveForm } from './PathActiveForm';
import { PathDraftForm } from './PathDraftForm';
import { PathsInMap } from './PathsInMap';
import { Intervals } from '../intervals/Intervals';
import { PathNotes } from '../notes/PathNotes';
import { StopsCommand } from '../commands/StopsCommand';
import { LinesCommand } from '../commands/LinesCommand';
import { LinesDraftCommand } from '../commands/LinesDraftCommand';
import { PathsCommand } from '../commands/PathsCommand';
import { PathsDraftCommand } from '../commands/PathsDraftCommand';
import { PathStopsCommand } from '../commands/PathStopsCommand';
import { PathStopsDraftCommand } from '../commands/PathStopsDraftCommand';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { EditionSelector } from '../../EditionSelector';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { StopsDraftCommand } from '../commands/StopsDraftCommand';

export class Paths extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {
                active: {
                    stops: [],
                    lines: [],
                    paths: []
                },
                draft: {
                    stops: [],
                    lines: [],
                    paths: []
                }
            },
            form: {
                active: {
                    line: undefined,
                    path: undefined
                },
                draft: {
                    line: undefined,
                    path: undefined
                },
                intervals: {
                    path: undefined
                },
                notes: {
                    path: undefined
                },
            },
            map: {
                show: false,
                trips: [],
                selectedStops: [],
                temporaryTrips: [],
            },
            render: {
                tab: "active",
                compare: false,
                filter: ""
            },
            pagination: {
                active: {
                    page: 1,
                    elementsPerPage: 10
                },
                draft: {
                    page: 1,
                    elementsPerPage: 10
                }
            },
            actions: {
                active: {
                    isLoadingStops: true,
                    isLoadingLines: true,
                    isLoadingPaths: false,
                    isUpdatingPath: false,
                    isUpdatingPathStops: false,
                    isDeletingPath: false,
                },
                draft: {
                    isLoadingStops: true,
                    isLoadingLines: true,
                    isLoadingPaths: false,
                    isUpdatingPath: false,
                    isUpdatingPathStops: false,
                    isDeletingPath: false,
                },
                isLoadingEditions: false,
            },
            commands: {
                active: {
                    stops: new StopsCommand(),
                    lines: new LinesCommand(),
                    paths: new PathsCommand(),
                    pathStops: new PathStopsCommand()
                },
                draft: {
                    stops: new StopsDraftCommand(),
                    lines: new LinesDraftCommand(),
                    paths: new PathsDraftCommand(),
                    pathStops: new PathStopsDraftCommand()
                },
                intervals: undefined,
                notes: undefined,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        const { actions } = this.state;

        actions.active.isLoadingLines = true;
        actions.active.isLoadingStops = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getLines(edition, "active");
            this.getStops(edition, "active");
        });
    }

    updateDraftNetwork() {
        const { actions } = this.state;

        actions.draft.isLoadingLines = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getLines(edition, "draft");
            this.getStops(edition, "draft");
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, updateData, updateAction, callback) {
        const { data, pagination, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, pagination[dataType].elementsPerPage);

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = result;
        if (0 !== totalPages) {
            pagination.page = pagination.page > totalPages ? totalPages : pagination.page;
        }
        else {
            pagination.page = 1;
        }

        // Update data
        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, pagination, actions, message } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = [];
        pagination[dataType].page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    listMapSuccessCallback(result, dataType, updateData, updateAction, transformDataCallback) {
        const { data, actions } = this.state;

        data[dataType][updateData] = result.map(a => "function" === typeof (transformDataCallback) ? transformDataCallback(a) : a);
        actions[dataType][updateAction] = false;

        // Update data
        this.setState({
            data: data, 
            actions: actions
        });
    }

    listMapErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, actions, message } = this.state;

        data[dataType][updateData] = [];
        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof (callback)) {
            callback(result.data);
        }
    }

    operationErrorCallback(messageReceived, updateAction, dataType) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    getStops(edition, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands } = this.state;

        commands[dataType].stops.get(
            edition,
            selectedProviderId,
            false,
            (a) => this.listMapSuccessCallback(a, dataType, "stops", "isLoadingStops", (a) => this.convertStop(a)),
            (a) => this.listMapErrorCallback(a, dataType, "stops", "isLoadingStops")
        );
    }

    getLines(edition, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingLines = true;
        commands[dataType].lines.get(
            edition,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "lines", "isLoadingLines", () => this.updateForm(dataType)),
            (a) => this.listErrorCallback(a, dataType, "lines", "isLoadingLines")
        );

        this.setState({
            actions: actions
        });
    }

    getPaths(edition, line, dataType, callback) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoadingPaths = true;
        commands[dataType].paths.getByLine(
            edition,
            line.id,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "paths", "isLoadingPaths", callback),
            (a) => this.listErrorCallback(a, dataType, "paths", "isLoadingPaths")
        );

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    updateForm(dataType) {
        const { data, form } = this.state;

        if (undefined === form[dataType].line) {
            return;
        }

        this.onChangeLine(data[dataType].lines.find(x => x.code === form[dataType].line.code), dataType);
    }

    // ----------------------

    onChangeLine(line, dataType) {
        const { edition } = this.context;
        const { form, map } = this.state;

        form[dataType].line = line;

        this.setState({
            form: form
        });

        if (null !== line && undefined !== line) {
            const callback = map.show ?
                () => this.onViewInMapClick(dataType) :
                undefined

            this.getPaths(edition, line, dataType, callback);
        }
        else {
            const { data } = this.state;

            data[dataType].paths = [];

            this.setState({
                data: data
            });
        }
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].path.obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].path.obj[value] = e;

        this.setState({
            form: form,
        });
    }

    onCheckValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].path.obj[value] = e.target.checked;

        this.setState({
            form: form,
        });
    }

    onCreateClick(isFromMap, dataType) {
        const { form } = this.state;

        if (undefined !== form[dataType].line && null !== form[dataType].line) {
            form[dataType].isFromMap = isFromMap;
            form[dataType].path = {
                title: "Criar",
                original: undefined,
                obj: { id: 0, line: form[dataType].line, code: "", extCode: "", externalCode: "", orientation: undefined, priority: 0 },
                priorityInputError: null,
                codeInputError: null,
                orientationInputError: null
            };

            this.setState({
                form: form
            });
        }
        else {
            this.setState({
                message: {
                    show: true,
                    message: "Selecione uma linha antes de criar um percurso",
                    style: "warning",
                    title: "Aviso",
                    icon: "alert"
                }
            });
        }
    }

    onViewInMapClick(dataType) {
        const { data, map } = this.state;

        map.show = true;
        map.temporaryTrips = [];
        map.selectedStops = [];

        data[dataType].stops = data[dataType].stops.map(stop => { stop.selected = false; return stop });


        if (0 < data[dataType].paths.length) {
            const { form } = this.state;

            const line = form[dataType].line;
            const lineColor = undefined === line || null === line || undefined === line.lineColor || null === line.lineColor ?
                "rgba(0,0,0,1)" :
                `rgba(${line.lineColor.foreColor.r},${line.lineColor.foreColor.g},${line.lineColor.foreColor.b},${line.lineColor.foreColor.a})`;

            map.trips = data[dataType].paths.reduce((trips, path) => {
                const pathStops = path.pathStops.map(pathStop => Object.assign({}, pathStop));
                pathStops.sort((a, b) => a.stopOrder - b.stopOrder);

                const pathTrips = this.createTrip(pathStops.map(pathStop => pathStop.stop), lineColor);

                return trips.concat(pathTrips);
            }, []);
        }

        this.setState({
            map: map,
        });
    }

    onEditPathClick(path, dataType) {
        const { form, render } = this.state;

        if(render.compare) {
            const { data } = this.state;

            path = data[dataType].paths.find(unmutedPath => unmutedPath.id === path.id);
        }

        form[dataType].path = {
            title: "Editar",
            original: path,
            obj: Object.assign({ id: 0, code: "", extCode: "", orientation: undefined, priority: 0 }, path),
            priorityInputError: null,
            codeInputError: null,
            orientationInputError: null
        };

        this.setState({
            form: form
        });
    }

    onPathFormExit(dataType) {
        const { form } = this.state;

        form[dataType].path = undefined;

        this.setState({
            form: form
        });
    }

    onDeleteClick(path, dataType) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o percurso "${path.code}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    id: path.id,
                    dataType: dataType
                }
            }
        });
    }

    onIntervalsClick(path, type) {
        const { commands, form } = this.state;

        switch (type) {
            case "active": commands.intervals = new PathsCommand();
                break;

            case "draft": commands.intervals = new PathsDraftCommand();
                break;

            default:
                break;
        }

        form.intervals.path = path;

        this.setState({
            commands: commands,
            form: form
        });
    }

    onIntervalsExit(message = undefined) {
        const { commands, form } = this.state;

        if (undefined !== message && null !== message) {
            this.setState({
                message: {
                    show: true,
                    message: message.message,
                    style: message.style,
                    title: message.title,
                    icon: message.icon
                }
            });
        }

        commands.intervals = undefined;
        form.intervals.path = undefined;

        this.setState({
            commands: commands,
            form: form
        });
    }

    onNotesClick(path, type) {
        const { commands, form } = this.state;

        switch (type) {
            case "active": commands.notes = new PathsCommand();
                break;

            case "draft": commands.notes = new PathsDraftCommand();
                break;

            default:
                break;
        }

        form.notes.path = path;

        this.setState({
            commands: commands,
            form: form
        });
    }

    onNotesExit(message = undefined) {
        const { commands, form } = this.state;

        if (undefined !== message && null !== message) {
            this.setState({
                message: {
                    show: true,
                    message: message.message,
                    style: message.style,
                    title: message.title,
                    icon: message.icon
                }
            });
        }

        commands.notes = undefined;
        form.notes.path = undefined;

        this.setState({
            commands: commands,
            form: form
        });
    }

    onSavePath(dataType) {
        if (this.isValidInput(dataType)) {
            const { edition } = this.context;
            const { form, commands, actions } = this.state;

            actions[dataType].isUpdatingPath = true;

            let callback = undefined;
            if (form[dataType].isFromMap) {
                actions[dataType].isUpdatingPathStops = true;
                callback = (a) => this.onSavePathStops(edition, a, dataType);
            }
            else {
                callback = () => this.getPaths(edition, form[dataType].line, dataType);
            }

            commands[dataType].paths.save(
                edition,
                form[dataType].path.obj,
                (a) => this.operationSuccessCallback(a, "isUpdatingPath", dataType, callback),
                (a) => this.operationErrorCallback(a, "isUpdatingPath", dataType)
            );

            this.setState({
                actions: actions
            });

            this.onPathFormExit(dataType);
        }
    }

    onSavePathStops(edition, path, dataType) {
        const { map, form, commands } = this.state;

        let stopOrder = 0;
        const pathStops = map.selectedStops.map(stop => {
            return {
                path: path,
                stop: stop,
                zones: [],
                prevDistance: '',
                restriction: 0,
                segmentBreakDuration: '',
                stopOrder: stopOrder++,
                inSpine: false
            }
        });

        commands[dataType].pathStops.createInBulk(
            edition,
            pathStops,
            (a) => this.operationSuccessCallback(a, "isUpdatingPathStops", dataType, () => this.getPaths(edition, form[dataType].line, dataType)),
            (a) => this.operationErrorCallback(a, "isUpdatingPathStops", dataType)
        );

        if (map.show) {
            this.onCloseViewInMapClick();
        }
    }

    onGiveValueToSelectedStop(stopIndex, selectedStops, dataType) {
        const { data, map } = this.state;

        if (0 === selectedStops.length) {
            if (-1 < stopIndex) {
                data[dataType].stops[stopIndex].selected = !data[dataType].stops[stopIndex].selected;
            } else {
                data[dataType].stops = data[dataType].stops.map(stop => {
                    stop.selected = false
                    return stop;
                });
            }
        } else {
            map.selectedStops = selectedStops;
        }

        this.setState({
            map: map,
            data: data
        });
    }

    onTemporaryTrips(newStops, remove) {
        const { map } = this.state;

        if (0 < newStops.length) {
            if (remove !== undefined) {
                let originTripToR = map.temporaryTrips.findIndex(mtt => mtt.originID === remove.id);
                let destinyTripToR = map.temporaryTrips.findIndex(mtt => mtt.destinationID === remove.id);

                if (originTripToR !== undefined) {
                    if (destinyTripToR !== undefined) {
                        map.temporaryTrips.splice(originTripToR);
                        map.temporaryTrips.splice(destinyTripToR);
                    } else {
                        map.temporaryTrips.splice(originTripToR, 1);
                    }
                } else if (destinyTripToR !== undefined) {
                    map.temporaryTrips.splice(destinyTripToR, 1);
                }
            }

            map.temporaryTrips = map.temporaryTrips.concat(this.createTrip(newStops, "rgba(102,204,255,1)"));
        }
        else {
            map.temporaryTrips = [];
        }

        this.setState({
            map: map
        });
    }

    onSearch(filter) {
        const { render } = this.state;

        render.filter = filter;

        this.setState({
            render: render
        });
    }

    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onToggleIsComparing() {
        const { render } = this.state;

        render.compare = !render.compare;

        this.setState({
            render: render
        });
    }

    onChangePage(page, dataType) {
        const { pagination } = this.state;

        pagination[dataType].page = page;

        this.setState({
            pagination: pagination
        });
    }

    onChangeElementsPerPage(elementsPerPage, dataType) {
        const { pagination } = this.state;

        pagination[dataType].elementsPerPage = elementsPerPage;

        this.setState({
            pagination: pagination
        });
    }

    onCloseViewInMapClick() {
        const { map } = this.state;

        map.show = false;
        map.trips = [];
        map.temporaryTrips = [];
        map.selectedStops = [];

        this.setState({
            map: map
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { edition } = this.context;
            const { form, commands } = this.state;

            commands[argument.dataType].paths.delete(
                edition,
                argument.id,
                (a) => this.operationSuccessCallback(a, "isDeletingPath", argument.dataType, () => this.getPaths(edition, form[argument.dataType].line, argument.dataType)),
                (a) => this.operationErrorCallback(a, "isDeletingPath", argument.dataType)
            );

            actions[argument.dataType].isDeletingPath = true;
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        if ((isNaN(form[dataType].path.obj.priority) && form[dataType].path.obj.priority < 0) || form[dataType].path.obj.priority === '') {
            form[dataType].path.priorityInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].path.obj.code || null === form[dataType].path.obj.code || "" === form[dataType].path.obj.code) {
            form[dataType].path.codeInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].path.obj.orientation || null === form[dataType].path.obj.orientation || "" === form[dataType].path.obj.orientation) {
            form[dataType].path.orientationInputError = 'error';
            errors++;
        }

        this.setState({
            form: form
        });

        return !(0 < errors);
    }

    convertStop(stop) {
        return {
            code: stop.code,
            position: [
                stop.latitude,
                stop.longitude
            ],
            hidden: stop.hidden,
            id: stop.id,
            isActive: stop.isActive,
            name: stop.name,
            latitude: stop.latitude,
            longitude: stop.longitude,
            selected: false
        };
    }

    createTrip(stops, lineColor) {
        return stops.reduce(
            (output, stop) => {
                if (undefined !== output.previousStop) {
                    output.trips.push({
                        originId: output.previousStop.id,
                        origin: [output.previousStop.latitude, output.previousStop.longitude],
                        destination: [stop.latitude, stop.longitude],
                        destinationId: stop.id,
                        lineColor: lineColor
                    });
                }
                output.previousStop = Object.assign({}, stop);

                return output;
            },
            { previousStop: undefined, trips: [] }
        ).trips;
    }

    // ----------------------

    renderTabOptions(render) {
        if ("active" === render.tab) {
            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={render.compare}
                            icons={false}
                            onChange={() => this.onToggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderPathsActive() {
        const { data, form, render, pagination, actions } = this.state;

        if (actions.active.isLoadingLines) {
            return (<LoadingSpinner />)
        }

        return (
            <PathsActive lines={data.active.lines}
                paths={data.active.paths}
                draftPaths={data.draft.paths}
                lineSelected={form.active.line}
                isLoadingPaths={actions.active.isLoadingPaths}
                isComparing={render.compare}
                filter={render.filter}
                currentPage={pagination.active.page}
                elementsPerPage={pagination.active.elementsPerPage}
                onChangePage={(a) => this.onChangePage(a, "active")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "active")}
                onChangeLine={(a) => this.onChangeLine(a, "active")}
                onIntervalsClick={(a) => this.onIntervalsClick(a, "active")}
                onNotesClick={(a) => this.onNotesClick(a, "active")}
                onEditClick={(a) => this.onEditPathClick(a, "active")}
                onDeleteClick={(a) => this.onDeleteClick(a, "active")} />
        );
    }

    renderPathsDraft() {
        const { data, form, render, pagination, actions } = this.state;

        if (actions.draft.isLoadingLines) {
            return (<LoadingSpinner />)
        }

        return (
            <PathsDraft lines={data.draft.lines}
                paths={data.draft.paths}
                lineSelected={form.draft.line}
                isLoadingPaths={actions.draft.isLoadingPaths}
                filter={render.filter}
                currentPage={pagination.active.page}
                elementsPerPage={pagination.active.elementsPerPage}
                onChangePage={(a) => this.onChangePage(a, "draft")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "draft")}
                onChangeLine={(a) => this.onChangeLine(a, "draft")}
                onIntervalsClick={(a) => this.onIntervalsClick(a, "draft")}
                onNotesClick={(a) => this.onNotesClick(a, "draft")}
                onEditClick={(a) => this.onEditPathClick(a, "draft")}
                onDeleteClick={(a) => this.onDeleteClick(a, "draft")} />
        );
    }

    renderTabs() {
        const { render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanager_tabs" activeKey={render.tab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Rede Ativa">
                        {this.renderPathsActive()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderPathsDraft()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(render)}
            </div>
        );
    }

    renderViewInMapButton(lineSelected, isLoading) {
        if (undefined === lineSelected) {
            return null;
        }

        const { render } = this.state;

        return (
            <Button disabled={isLoading} onClick={() => this.onViewInMapClick(render.tab)}>VER MAPA</Button>
        );
    }

    renderButtons() {
        const { render, form, actions } = this.state;

        if ("active" === render.tab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    {this.renderViewInMapButton(form.active.line, actions.active.isLoadingStops || actions.active.isLoadingPaths)}
                    <Button onClick={() => this.onCreateClick(false, render.tab)}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        if ("draft" === render.tab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    {this.renderViewInMapButton(form.draft.line, actions.draft.isLoadingStops || actions.draft.isLoadingPaths)}
                    <Button onClick={() => this.onCreateClick(false, render.tab)}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        return null;
    }

    renderMap() {
        const { map } = this.state;

        if (!map.show) {
            return null;
        }

        const { render, data, form } = this.state;

        return (
            <PathsInMap show={map.show}
                onExit={() => this.onCloseViewInMapClick()}
                stops={data[render.tab].stops}
                trips={map.trips}
                tempTrips={map.temporaryTrips}
                giveValueToSelectedStop={(a, b) => this.onGiveValueToSelectedStop(a, b, render.tab)}
                temporaryTrips={(a, b) => this.onTemporaryTrips(a, b)}
                lineSelected={form.active.line}
                saveInDB={() => this.onSavePath(render.tab)}
                mapSelectedStops={map.selectedStops}
                onCreateClick={(a) => this.onCreateClick(a, render.tab)} />
        );
    }

    renderActiveForm() {
        const { form } = this.state;

        if (undefined === form.active.path) {
            return null;
        }

        return (
            <PathActiveForm show={true}
                form={form.active.path}
                line={form.active.line}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "active")}
                onSave={() => this.onSavePath("active")}
                onHide={() => this.onPathFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form } = this.state;

        if (undefined === form.draft.path) {
            return null;
        }

        return (
            <PathDraftForm show={true}
                form={form.draft.path}
                line={form.draft.line}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onCheckValue={(a, b) => this.onCheckValue(a, b, "draft")}
                onSave={() => this.onSavePath("draft")}
                onHide={() => this.onPathFormExit("draft")} />
        );
    }

    renderIntervals() {
        const { edition } = this.context;
        const { form, commands } = this.state;

        if (null == form.intervals.path || undefined === form.intervals.path) {
            return null;
        }

        return (
            <Intervals edition={edition}
                elementId={form.intervals.path.id}
                command={commands.intervals}
                onHide={(a) => this.onIntervalsExit(a)} />
        );
    }

    renderNotes() {
        const { edition } = this.context;
        const { form, commands } = this.state;

        if (null == form.notes.path || undefined === form.notes.path) {
            return null;
        }

        return (
            <PathNotes edition={edition}
                elementId={form.notes.path.id}
                command={commands.notes}
                onHide={(a) => this.onNotesExit(a)} />
        );
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    render() {
        const { actions, message, dialog } = this.state;

        return (
            <div>
                <EditionSelector />

                <div>
                    <TitleRow title="Percursos" showSeparator={true}>
                        <Col className="padding-0" xs={5} sm={3} md={4}>
                            {this.renderButtons()}
                        </Col>
                        <Col className="padding-0" xs={7} sm={9} md={8}>
                            <div className="search-bar">
                                <SearchBar onSearch={(a) => this.onSearch(a)} />
                            </div>
                        </Col>
                    </TitleRow>

                    <div className="margin-top-15">
                        {this.renderTabs()}
                    </div>
                </div>

                {this.renderActiveForm()}
                {this.renderDraftForm()}
                {this.renderMap()}
                {this.renderIntervals()}
                {this.renderNotes()}

                {
                    this.renderOperationFeedback(
                        "A Executar...",
                        actions.active.isUpdatingPathStops || actions.active.isUpdatingPath || actions.active.isDeletingPath || actions.draft.isUpdatingPath || actions.draft.isDeletingPath
                    )
                }
                {this.renderOperationFeedback("A Carregar Edição...", actions.isLoadingEditions)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/paths/Paths.js